import { useQueryClient } from '@tanstack/react-query';
import { useApplicationLocalStorage } from '../../application-hook';
import { SAPApplicationParameters } from '@platform/client/schemas';
import { useState } from 'react';
import { ApplicationPageProps } from '../../Application';
import { Application, Cohorts } from '@platform/client';
import { CohortDetails } from '../../program/shared/CohortDetails';
import { ErrorBox } from '@platform/components';


export const SAPConfirmAndSubmit = (props: ApplicationPageProps) => {
  const [failed, setFailed] = useState(false);
  const { getApplicationData, getApplicationDataByKey } = useApplicationLocalStorage<SAPApplicationParameters>(
    props.dataKey,
  );
  const queryClient = useQueryClient();
  const submitSAPMutation = Application.useSubmitSapApplication();
  const { data: cohortData, isSuccess } = Cohorts.useGetCohort(getApplicationDataByKey('cohort'));
  const submit = () => {
    submitSAPMutation.mutate(
      {
        data: {
          ...getApplicationData(),
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: Application.getGetProfessionalApplicationStatusQueryKey(),
          });
        },
        onError: () => {
          setFailed(true);
        },
      },
    );
  };

  return (
    <>
      {isSuccess && cohortData && <CohortDetails {...props} cohortData={cohortData} onSubmit={submit} onBack={props.onBack} isSubmitting={submitSAPMutation.isPending || submitSAPMutation.isSuccess} />}
      {failed && (
        <ErrorBox showAlertTriangle={true}>
          There was an error submitting your application. Please try again later.
        </ErrorBox>
      )}
    </>
  );
};
